var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.computedClass.length === 0)?_c('figure',{staticClass:"c-image"},[_c('img',{attrs:{"src":_vm.computedSrc,"alt":_vm.alt}})]):_c('div',{class:['c-image', _vm.computedClass],style:(`background-image: url(${_vm.computedSrc})`)})
}
var staticRenderFns = []

export { render, staticRenderFns }